var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'morelist': true, 'none': _vm.isjh}},[_c('i',{staticClass:"icon i_list"}),_c('em',[_vm._v("点我阅读")]),_vm._v("更多劲爆内容 "),_c('span',{staticClass:"icon i_goto"})])}
var staticRenderFns = []

export { render, staticRenderFns }